import { ContentBlock, Box } from 'braid-design-system';
import type React from 'react';

import { PageHead } from '../../components/PageHead/PageHead';
import aboutUsImage1 from '../../images/about-banner-1.jpg';
import aboutUsImage2 from '../../images/about-banner-2.jpg';

import * as styles from './AboutUs.css';

export const AboutUs: React.FC = () => (
  <ContentBlock width="medium">
    <PageHead
      title="About us"
      description="Learn about Fae Forest, a Melbourne studio creating whimsical handcrafted fairy garden miniatures."
      path="/about-us"
    />
    <Box paddingY="large">
      <div className={styles.header}>
        <h1 className={styles.title}>About Fae Forest</h1>
        <p className={styles.subtitle}>
          Where magic takes root in everyday spaces
        </p>
      </div>

      <div className={styles.content}>
        <p className={styles.paragraph}>
          Fae Forest is a small, Melbourne-based studio creating whimsical,
          handcrafted pieces designed to inspire play, imagination, and quiet
          moments of wonder.
        </p>

        <div
          className={styles.aboutUsImage}
          style={{ backgroundImage: `url(${aboutUsImage1})` }}
        />

        <p className={styles.paragraph}>
          Every product begins as a sketch, an idea scribbled during a moment of
          curiosity. From there, it is carefully shaped through digital
          modelling, 3D printed, and lovingly hand-finished. This blend of
          modern tools and traditional craftsmanship allows us to create objects
          that feel both magical and made-by-hand.
        </p>

        <div
          className={styles.aboutUsImage}
          style={{ backgroundImage: `url(${aboutUsImage2})` }}
        />

        <p className={styles.paragraph}>
          All Fae Forest designs are original and exclusive. You won't find our
          creations anywhere else. Each piece is designed in-house, from first
          concept to final brushstroke.
        </p>

        <p className={styles.paragraph}>
          Our products are made to be touched, explored, and played with. That
          is why every item is thoroughly tested by real humans before it ever
          finds its way into the world. Only pieces that feel right, those that
          are durable, delightful, and full of story, make it into our
          collection.
        </p>
      </div>
    </Box>
  </ContentBlock>
);
